import React from 'react';
import { useJwt } from '../context/JwtContext';

// Toast animation styles
const toastStyles = `
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOutDown {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(20px);
    }
  }

  .toast-enter {
    animation: fadeInUp 0.3s ease-out;
  }

  .toast-exit {
    animation: fadeOutDown 0.3s ease-in;
  }
`;

/**
 * JWT Toast Component
 * @returns {JSX.Element} JwtToast component
 */
const JwtToast = () => {
  const { showToast, toastMessage } = useJwt();

  return (
    <>
      {/* Add toast animation styles */}
      <style dangerouslySetInnerHTML={{ __html: toastStyles }} />
      
      {/* Toast notification */}
      {showToast && (
        <div
          className="fixed top-4 right-4 z-50 bg-green-500 text-white px-4 py-2 rounded-md shadow-lg toast-enter"
          style={{
            animation: 'fadeInUp 0.3s ease-out'
          }}
        >
          {toastMessage}
        </div>
      )}
    </>
  );
};

export default JwtToast;
